module.exports = __webpack_public_path__ + "img/img-2.822f72ce.webp";